module.exports = __webpack_public_path__ + "static/media/sidebar-3.34535b95.jpg";